import React, { Component } from "react";
import Slider from "react-slick";
import bmw from '../assets/images/bmw.jpg'
import Ford from '../assets/images/Ford.jpg'
import Lamborghini from '../assets/images/Lamborghini.jpg'
import Toyota from '../assets/images/Toyota.jpg'
import tesla from '../assets/images/tesla.jpg'
import porsche from '../assets/images/porsche.jpg'
import subaru from '../assets/images/subaru.jpg'
import nissan from '../assets/images/nissan.jpg'

export default class SwipeToSlide extends Component {
  render() {
    const settings = {
      dots:'false',
      infinite: true,
      slidesToShow: 5,
      slidesToScroll:1,
      initialSlide:0,
      responsive:[
        {
        breakpoint:1024,
        settings:{
          slidesToShow:4,
          slidesToScroll:4,
          infinite:true,
          dots:false
        }
      },
      {
        breakpoint:600,
        settings:{
          slidesToShow:3,
          slidesToScroll:3,
          infinite:true,
          dots:false
        }
      },
      {
        breakpoint:480,
        settings:{
          slidesToShow:2,
          slidesToScroll:2,
          infinite:true,
          dots:false
        }
      },
      {
        breakpoint:320,
        settings:{
          slidesToShow:1,
          slidesToScroll:1,
          infinite:true,
          dots:false
        }

      }

    ]
    
    };
    return (
      <div className="slider1-child">
        <h2>Browse by make</h2>
        <Slider {...settings}>

          <div >
            <div className="cards-slider1">
              {/* <div> */}
                <img src={Toyota}
                 style={{width: '100%', height: '150px', borderTopLeftRadius: '8px',
                  borderTopRightRadius: '8px'
                }}></img>
                <p className='carsBrandName' style={{ textAlign: 'center', fontWeight: 'bold' }}>Toyota</p>
              {/* </div> */}
            </div>
          </div>
          
          <div>
            <div className="cards-slider1">
              {/* <div> */}
                <img src={Lamborghini} style={{
                  width: '100%', height: '150px', borderTopLeftRadius: '8px',
                  borderTopRightRadius: '8px'
                }}></img>
                <p className='carsBrandName' style={{ textAlign: 'center', fontWeight: 'bold' }}>Lamborghini</p>
              </div>
            </div>
          {/* </div> */}
          <div>
            <div className="cards-slider1">
              {/* <div> */}
                <img src={Ford} style={{
                  width: '100%', height: '150px', borderTopLeftRadius: '8px',
                  borderTopRightRadius: '8px'
                }}></img>
                <p className='carsBrandName' style={{ textAlign: 'center', fontWeight: 'bold' }}>Ford</p>
              {/* </div> */}
            </div>
          </div>
          <div>
            <div className="cards-slider1">
              {/* <div> */}
                <img src={tesla} style={{
                 width: '100%', height: '150px', borderTopLeftRadius: '8px',
                  borderTopRightRadius: '8px'
                }}></img>
                <p className='carsBrandName' style={{ textAlign: 'center', fontWeight: 'bold' }}>tesla</p>
              {/* </div> */}
            </div>
          </div>
          <div>
            <div className="cards-slider1">
              {/* <div> */}
                <img src={porsche} style={{
                  width: '100%', height: '150px', borderTopLeftRadius: '8px',
                  borderTopRightRadius: '8px'
                }}></img>
                <p className='carsBrandName' style={{ textAlign: 'center', fontWeight: 'bold' }}>porsche</p>
              </div>
            {/* </div> */}
          </div>
          <div>
            <div className="cards-slider1">
              {/* <div> */}
                <img src={bmw} style={{
                 width: '100%', height: '150px', borderTopLeftRadius: '8px',
                  borderTopRightRadius: '8px'
                }}></img>
                <p className='carsBrandName' style={{ textAlign: 'center', fontWeight: 'bold' }}>bmw</p>
              </div>
            {/* </div> */}
          </div>
          <div>
            <div className="cards-slider1">
              {/* <div> */}
                <img src={subaru} style={{
                 width: '100%', height: '150px', borderTopLeftRadius: '8px',
                  borderTopRightRadius: '8px'
                }}></img>
                <p className='carsBrandName' style={{ textAlign: 'center', fontWeight: 'bold' }}>subaru</p>
              {/* </div> */}
            </div>
          </div>
          <div>
            <div className="cards-slider1">
              {/* <div> */}
                <img src={nissan} style={{
                  width: '100%', height: '150px', borderTopLeftRadius: '8px',
                  borderTopRightRadius: '8px'
                }}></img>
                <p className='carsBrandName' style={{ textAlign: 'center', fontWeight: 'bold' }}>nissan</p>
              {/* </div> */}
            </div>
          </div>
        </Slider>
      </div>
    );
  }
}